import DioramaPanel from "../../../lib/services/scene/diorama_panel";
import ShaderService from "../../../lib/services/shader/shader_service";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";
import BoxCollisionVolume from "../../../lib/services/collision/box_collision_volume";
import Stage from "../../../lib/services/stage/stage";

export const MushroomType = {
short: 0,
medium: 1,
tall: 2,
} as const;

export default class Mushroom extends DioramaPanel 
{
   mushroom_type:number;
  constructor(key: string,texture_name:string,width:number,height:number,mushroom_type:number) 
  {
    super(key,"unlit_texture_alpha",texture_name,width,height);
    this.mushroom_type = mushroom_type;

   // mush_sh0 volume[0] size 0.435,0.310,0.629
    //mush_sh0 volume[0] offset -0.032,0.205,-0.268

    const shrink = 0.75;

    if(mushroom_type == MushroomType.short)
    {
        const cbox = new BoxCollisionVolume(
            0.326,0.272,0.472,   // width, height, depth
            0.008,0.217,-0.105,   // offset x, y, z
            "nav",
            false
            );
        this.add_collision_volume(cbox);
    }
    else if(mushroom_type == MushroomType.medium)
    {
       
        const cbox = new BoxCollisionVolume(
             0.313,0.520,0.352,   // width, height, depth
            -0.021,0.347,-0.156,   // offset x, y, z
            "nav",
            false
            );
        this.add_collision_volume(cbox);
    }
    else if(mushroom_type == MushroomType.tall)
    {
        const cbox = new BoxCollisionVolume(
                 0.364,0.783,0.290,   // width, height, depth
            -0.032,0.477,-0.123,   // offset x, y, z
                "nav",
                false
            );
        this.add_collision_volume(cbox);
    }


  }

  async build(device: GPUDevice,format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {
       await super.build(device,format,shader_service,resource_service);
       this.register_collisions(Stage.instance().collision_service);

       
 }    
  
  tick(delta_time: number): void 
  {
     
  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
     super.prepare(device,camera);
     
  }
  
  draw(pass: GPURenderPassEncoder): void 
  {
      super.draw(pass);
  }
   
}